'use strict';

import gsap from "gsap";

class BlockHero {

	constructor($target) {

		//Private properties
		$target;
		let video = document.querySelectorAll('.block_hero__video')
		let titles = $('.block_hero__title')
		var videoMediumScreen = window.matchMedia("(min-width:768px)");
		let btnDown = document.querySelectorAll('.block_hero__btn-down');
		let scroll_Timelines = []

        //random numbers
		var slideIndex = Math.floor(Math.random() * video.length );

		function init(){
            
			showElementOnEnter();
            randomVideos();
			shuffleTitles();
		}

		function initTitlesTimeline(forVideoIndex){
			let videoElement = video[forVideoIndex]
			let totalLength = videoElement.duration

			let fadeInDuration = 0.8;
			let fadeOutDuration = 0.8;

			//Reduce animation by the length of the intro logo animation
			let animationLength = (totalLength - 3)-((fadeInDuration+fadeOutDuration)*titles.length);

			let titleShowLength = (animationLength/titles.length);

			scroll_Timelines[forVideoIndex] = gsap.timeline({paused:true, repeat:0});
			
			//Added empty animation to create a delay and wait for the all3 logo in the video to fadeout
			scroll_Timelines[forVideoIndex].to(titles[0],{duration:2.5, opacity:0})
			titles.each((index,titleElement) => {
				scroll_Timelines[forVideoIndex].fromTo(titleElement, {y:20, opacity:0}, {y:0, opacity:1, duration:fadeInDuration})
				scroll_Timelines[forVideoIndex].to(titleElement, {opacity:0, duration:fadeOutDuration, delay:titleShowLength})
			})
		}

		const shuffleArray = (array) => {

			var currentIndex = array.length
			var temporaryValue 
			var randomIndex;
			
			// While there remain elements to shuffle...
			while (0 !== currentIndex) {
			
				// Pick a remaining element...
				randomIndex = Math.floor(Math.random() * currentIndex);
				currentIndex -= 1;
			
				// And swap it with the current element.
				temporaryValue = array[currentIndex];
				array[currentIndex] = array[randomIndex];
				array[randomIndex] = temporaryValue;
			}
			
			return array;

		}

        const shuffleTitles = () => {
			shuffleArray(titles)
        }

		const randomVideos = () => {

			for (var i = 0; i < video.length; i++) {
				
				//listen to all videos when videos ends
				video[i].onended = (e) => {
					
					// reset the index to 0 when reach the limit
					if ( ( slideIndex + 1 ) === video.length) {
						slideIndex = -1 
					}
				
                    videoSlides(slideIndex+=1)
				}

				video[i].addEventListener("loadedmetadata", (e) => {
					if(!scroll_Timelines[slideIndex]){
						initTitlesTimeline(slideIndex)
						scroll_Timelines[slideIndex].play(0)
					}
				})

				video[i].addEventListener("play", (e) => {

					// Once the first video is playing, we start the timeline animation
					if(scroll_Timelines[slideIndex]){
						scroll_Timelines[slideIndex].play(0)
					}

				})
				
			}		
			
			videoSlides(slideIndex)

		};


			const videoSlides = (n) => {

				//variables
				var videoSlides = video;								
				let videoDeskSrc = videoSlides[n].dataset.videoTargetDesk
				let videoMobSrc  = videoSlides[n].dataset.videoTargetMob
                
				// we hide all videos
				for ( var i = 0; i < videoSlides.length; i++) {
					videoSlides[i].style.display = "none";  
				}				
				// desktop and mobile src is attach to the DOM
				( videoMediumScreen.matches) ? videoSlides[n].setAttribute("src", videoDeskSrc) : videoSlides[n].setAttribute("src", videoMobSrc)
				//show video
				videoSlides[n].style.display = "block";
                //play video
				
                videoSlides[n].play();
                videoSlides[n].addEventListener('timeupdate', (e) => {

                    if(videoSlides[n].currentTime > 3){
                    }

				})
				
                            
		}




		$(btnDown).each((index, value) => {
		
			$(value).on("click", function (e) {
				let parent = $(value).parent().parent().parent().next();
				

				$(".blog-post").animate({ opacity : 0}, 800, () => {

				$('html,body').animate({
					scrollTop: $(parent).offset().top},
					'slow', ( ) => {
						$(".blog-post").animate({ opacity : 1}, 800)
					});
				})
				

			});

		});

		function showElementOnEnter(){

			///if is the homepage
			if ( (window.location.pathname == '/') ){
				if(video.scrollTop==0){
				}
			}

		}

		init();
		return {

			//Public properties
			// name:name,

			publicBlockHero:function(string){

		

			}

		}

	}

}

export default BlockHero;